import { WORKOUT_KEY } from '../../../../../modules/workout/model/constants/key'
import updateWorkoutAction from '../update'
import WORKOUTS_ACTION from '../../constants/action'

export default function updateNotesWorkoutAction (value) {
  return updateWorkoutAction({
    type: WORKOUTS_ACTION.UPDATE_NOTE,
    payload: {
      key: WORKOUT_KEY.NOTES,
      value
    }
  })
}
